<template>
    <div class="d-inline pr-2 pl-2">
        <button class="btn btn-success copy-hashtags-button-prop mb-2 w-100">
            <i class="far fa-clipboard"></i>
            <span class="innerText">{{ button }}</span>
        </button>
        <p style="position: absolute; left: -99999999em;">
            <template v-if="includeThreeDots"> • <br />• <br />• <br />• <br />• <br /> </template>
            {{ propHashtags }}
        </p>
        <b-form-checkbox switch class="pb-2" v-model="includeThreeDots">
            Include black dots
        </b-form-checkbox>
    </div>
</template>

<script>
import ClipboardJS from "clipboard";
window.ClipboardJS = ClipboardJS;

export default {
    name: "buttonAddHashtagSet",
    props: {
        propHashtags: String,
    },
    data() {
        return {
            button: "Copy to clipboard",
            includeThreeDots: true,
        };
    },
    methods: {
        initCopyHashtags() {
            var clipboard = new ClipboardJS(".copy-hashtags-button-prop", {
                target: function (trigger) {
                    return trigger.nextElementSibling;
                },
            });

            clipboard.on("success", (e) => {
                e.trigger.children[1].innerText = "Copied!";
                setTimeout(() => {
                    e.trigger.children[1].innerText = this.button;
                }, 2000);
            });
        },
    },

    mounted() {
        // Initialise hashtags copy
        this.initCopyHashtags();
    },
};
</script>
